import React from 'react';
import './App.css';
import { Route, Routes } from 'react-router-dom';
import routerPaths from 'src/integration/config/routerPaths';
import GlobalStyle from 'src/integration/styles/globalStyle';
import LoginPage from "src/presentation/pages/LoginPage";
import AuthProvider from 'src/toolkit/services/AuthProvider';
import PrivateRoute from 'src/presentation/components/PrivateRoute';
import PublicRoute from 'src/presentation/components/PublicRoute';
import NewDemoPage from 'src/presentation/pages/NewDemoPage';

function App() {
  return (
   <AuthProvider>
      <GlobalStyle />
      <Routes>
        <Route element={<PrivateRoute />}>
          <Route path={routerPaths.home()} element={<NewDemoPage />} />
        </Route>
        <Route element={<PublicRoute />}>
          <Route path={routerPaths.login()} element={<LoginPage />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}

export default App;
